<div class="main-content side-content mt-10 ">
  <div class="main-container container-fluid" [formGroup]="DasboardForm">
    <div class="inner-body">
      <!-- Page Header -->
      <div class="page-header">
        <div>
          <h2 class="main-content-title tx-18 mg-b-5">Dashboard</h2>
          <ol class="breadcrumb">
            <!-- <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li> -->
            <!-- <li class="breadcrumb-item active" aria-current="page">Project Dashboard</li> -->
          </ol>
        </div>
        <!-- <div class="d-flex">
            <div class="justify-content-center">
              <button type="button" class="btn btn-white btn-icon-text my-2 me-2">
                <i class="fe fe-download me-2"></i> Import
              </button>
              <button type="button" class="btn btn-white btn-icon-text my-2 me-2">
                <i class="fe fe-filter me-2"></i> Filter
              </button>
              <button type="button" class="btn btn-primary my-2 btn-icon-text">
                <i class="fe fe-download-cloud me-2"></i> Download Report
              </button>
            </div>
          </div> -->
      </div>
      <!-- End Page Header -->

      <!--Row-->
      <div class="row row-sm">
        <div class="col-sm-12">
          <div class="row">
  <div class="col-sm-2">
              <div class="form-group">
                <div class="">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>Session</mat-label>
                    <mat-select #select232 placeholder="Session" class="colorblack" formControlName="SnNo" (selectionChange)="onSessionChange($event.value)">
                      <mat-select-filter *ngIf="select232.focused" [placeholder]="'Filter'" [displayMember]="'SnName'"
                        [array]="sessionList" (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                      <mat-option *ngFor="let item of SessionFilterList" [value]="item.SnNo">
                        {{item.SnName}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-group">
                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>
                    Course
                  </mat-label>
                  <mat-select #select22 placeholder="Course" class="colorblack" formControlName="CoCode" (selectionChange)="onCourseChange()">
                    <mat-select-filter *ngIf="select22.focused" [placeholder]="'Programme'" [displayMember]="'CoName'"
                      [array]="courseList" (filteredReturn)="filteredCourseList =$event">
                    </mat-select-filter>
                    <mat-option *ngFor="let item of filteredCourseList" [value]="item.CoCode"
                      (click)="FetchCollegeData(item.CoCode)">
                      {{ item | displayValue:'CoCode':'CoName' }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="col-sm-2">
              <div class="form-group">
                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>
                    College
                  </mat-label>
                  <mat-select #select225 placeholder="College" class="colorblack" formControlName="CgCode" (selectionChange)="onCollegeChange()">
                    <mat-select-filter *ngIf="select225.focused" [placeholder]="'Study Center Name'"
                      [displayMember]="'CgName'" [array]="collegedataList"
                      (filteredReturn)="filteredListCollege =$event">
                    </mat-select-filter>
                    <mat-option *ngFor="let item of filteredListCollege" [value]="item.CgCode">
                      {{ item | displayValue:'CgCode':'CgName' }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
             <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline"
                                                        class="example-full-width date-field">
                                                        <mat-label>From Date</mat-label>
                                                        <input matInput [matDatepicker]="fromPicker"
                                                            formControlName="FromDate"  (dateChange)="validateDates()" maxlength="10" [max]="today" placeholder="DD/MM/YYYY">
                                                        <mat-datepicker-toggle matSuffix
                                                            [for]="fromPicker"></mat-datepicker-toggle>
                                                        <mat-datepicker #fromPicker></mat-datepicker>
                                                         <mat-error *ngIf="DasboardForm.controls.FromDate.errors?.maxDate">
                                                            From Date cannot be greater than today
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline"
                                                        class="example-full-width date-field">
                                                        <mat-label>To Date</mat-label>
                                                        <input matInput [matDatepicker]="toPicker"
                                                            formControlName="ToDate"  (dateChange)="validateDates()" maxlength="10" placeholder="DD/MM/YYYY"
         [max]="today" placeholder="To Date">
                                                        <mat-datepicker-toggle matSuffix
                                                            [for]="toPicker"></mat-datepicker-toggle>
                                                        <mat-datepicker #toPicker></mat-datepicker>
                                                          <!-- From Date not selected -->
                                                           <mat-error
                                                            *ngIf="DasboardForm.controls.ToDate.touched && DasboardForm.controls.ToDate.errors?.fromRequired">
                                                            Please select From Date first
                                                        </mat-error>

                                                        <mat-error
                                                            *ngIf="DasboardForm.controls.ToDate.touched && DasboardForm.controls.ToDate.errors?.invalidDate">
                                                            To Date cannot be earlier than From Date
                                                        </mat-error>
                                                        <mat-error *ngIf="DasboardForm.controls.ToDate.errors?.maxDate">
                                                            To Date cannot be greater than today
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
</div>
          <div class="row">

  <div class="col-sm-3 card-width"
       *ngFor="let card of cards"
       >
<div class="card custom-card" (click)="card.click()">
    <app-kpi-card 
      [title]="card.title"
      [value]="card.value"
      [image]="card.image"
      bgColor="#ffffff"
      titleColor="#1254f4"
      valueColor="#1d212f"
      titleSize="13px"
      valueSize="22px"
      imageSize="42px"
      titleWeight="bold">
    </app-kpi-card> 
</div>
 </div>

</div>
          <!-- <div class="row">

  <div class="col-sm-3 card-width" (click)="college()">
    <app-kpi-card
  title="TOTAL COLLEGES"
  [value]="totalCollege"
  image="../../assets/img/college.png"
  bgColor="#ffffff"
  titleColor="#1254f4"
  valueColor="#1d212f"
  titleSize="13px"
  valueSize="22px"
  imageSize="45px"
  titleWeight="bold">
</app-kpi-card>
  </div>

  <div class="col-sm-3 card-width" (click)="course()">
        <app-kpi-card
  title="TOTAL COURSES"
  [value]="totalCourses"
  image="../../assets/img/online-course.png"
  bgColor="#ffffff"
  titleColor="#1254f4"
  valueColor="#1d212f"
  titleSize="13px"
  valueSize="22px"
  imageSize="45px"
  titleWeight="bold">
</app-kpi-card>
  </div>

  <div class="col-sm-3 card-width" (click)="exam()">
     <app-kpi-card
  title="TOTAL EXAMS"
  [value]="totalExams"
  image="../../assets/img/exam.png"
  bgColor="#ffffff"
  titleColor="#1254f4"
  valueColor="#1d212f"
  titleSize="13px"
  valueSize="22px"
  imageSize="45px"
  titleWeight="bold">
</app-kpi-card>
  </div>

  <div class="col-sm-3 card-width" (click)="Request()">
    <app-kpi-card
  title="STUDENT REQUEST"
  [value]="totalCount"
  image="../../assets/img/ask-question.png"
  bgColor="#ffffff"
  titleColor="#1254f4"
  valueColor="#1d212f"
  titleSize="13px"
  valueSize="22px"
  imageSize="40px"
  titleWeight="bold">
</app-kpi-card>
  </div>

  <div class="col-sm-3 card-width" (click)="grievance()">
    <app-kpi-card
  title="TOTAL GRIEVANCE"
  [value]="totalGrievance"
  image="../../assets/images/complain.png"
  bgColor="#ffffff"
  titleColor="#1254f4"
  valueColor="#1d212f"
  titleSize="13px"
  valueSize="22px"
  imageSize="45px"
  titleWeight="bold">
</app-kpi-card>
  </div>

</div> -->
          <!-- <div class="row">
            <div class="col-sm-3 card-width">
              <div class="card custom-card" (click)="college()">
                <div class="card-body">
                  <div class="card-item">

                    <div class="card-item-body">
                      <div class="card-item-stat">
                        <div class="card-item-icon floatleft">
                          <img src="../../assets/img/college.png">
                        </div>
                        <div class="card-item-title mb-2">
                          <label class="main-content-label tx-13 font-weight-bold mb-1">Total Colleges </label>

                        </div>
                        <h4 class="font-weight-bold">{{totalCollege}}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-3 card-width">
              <div class="card custom-card" (click)="course()">
                <div class="card-body">
                  <div class="card-item">
                    <div class="card-item-icon">
                      <img src="../../assets/img/online-course.png">
                    </div>
                    <div class="card-item-title mb-2">
                      <label class="main-content-label tx-13 font-weight-bold mb-1">Total Courses </label>

                    </div>
                    <div class="card-item-body">
                      <div class="card-item-stat">
                        <h4 class="font-weight-bold">{{totalCourses}}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-3 card-width">
              <div class="card custom-card" (click)="exam()">
                <div class="card-body">
                  <div class="card-item">
                    <div class="card-item-icon">
                      <img src="../../assets/img/exam.png">
                    </div>
                    <div class="card-item-title mb-2">
                      <label class="main-content-label tx-13 font-weight-bold mb-1">Total Exams </label>

                    </div>
                    <div class="card-item-body">
                      <div class="card-item-stat">
                        <h4 class="font-weight-bold">{{totalExams}}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-3 card-width">
              <div class="card custom-card" (click)="Request()">
                <div class="card-body">
                  <div class="card-item">
                    <div class="card-item-icon">
                      <img src="../../assets/img/ask-question.png">
                    </div>
                    <div class="card-item-title mb-2">
                      <label class="main-content-label tx-13 font-weight-bold mb-1">Student Request </label>

                    </div>
                    <div class="card-item-body">
                      <div class="card-item-stat">
                        <h4 class="font-weight-bold">{{totalCount}}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="col-sm-3 card-width">
              <div class="card custom-card" (click)="grievance()">
                <div class="card-body">
                  <div class="card-item">
                    <div class="card-item-icon">
                      <img src="../../assets/images/complain.png">
                    </div>
                    <div class="card-item-title mb-2">
                      <label class="main-content-label tx-13 font-weight-bold mb-1">Total Grievance </label>

                    </div>
                    <div class="card-item-body">
                      <div class="card-item-stat">
                        <h4 class="font-weight-bold">{{totalGrievance}}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          </div> -->
          <!-- <hr class="mt-2"> -->
<div class="card-container">
  <app-kpi-card 
    *ngFor="let card of kpiCards"
    [title]="card.title"
    [value]="card.value"
    [icon]="card.icon"
    [color]="card.color">
  </app-kpi-card> 
</div>
          <!-- <div class="card-container">
            <div class="kpi-card" *ngFor="let card of kpiCards" [ngClass]="card.color">

              <div class="card-content">

                <div class="text-section">
                  <div class="card-title">
                    {{card.title}}
                  </div>
                  <div class="card-value">
                    {{card.value | number}}
                  </div>
                </div>

                <div class="icon-section">
                  <mat-icon>{{card.icon}}</mat-icon>
                </div>

              </div>

            </div>
          </div> -->
          <div class="row">
            <!-- <div class="col-sm-6">
               <div class="card">
                <div class="row">
                  <div class="col-sm-5 mt-1 ml1 float-end">
                    <div class="form-group">
                      <div>
                        <mat-form-field appearance="outline">
                          <mat-label>
                              Select
                          </mat-label>
                          <mat-select #select53 formControlName="StuCount">
                              <mat-option value="district" (click)="StuPerformance('district')">
                                District
                              </mat-option>
                              <mat-option value="Town" (click)="StuPerformance('town')">
                                Town
                              </mat-option>
                              <mat-option value="course" (click)="StuPerformance('course')">
                                Course
                              </mat-option>
                              <mat-option value="College" (click)="StuPerformance('college')">
                                College
                              </mat-option>
                          </mat-select>
                      </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 mr1" *ngIf="Showcollege2">
                    <div class="form-group">
                      <div class="">
                        <mat-form-field appearance="outline" class="example-full-width mt-2">
                          <mat-label>
                          </mat-label>
                          <mat-select #select52 class="colorblack" formControlName="College2">
                            <mat-select-filter *ngIf="select52.focused" [placeholder]="'Filter'"
                              [displayMember]="'CgName'" [array]="collegedataList"
                              (filteredReturn)="filteredListCollege =$event">
                            </mat-select-filter>
                            <mat-option value="SelectedData">
                              All
                            </mat-option>
                            <mat-option *ngFor="let item of filteredListCollege" [value]="item.CgCode"
                              (click)="loadgraph('college')">
                              {{item.CgCode}} - {{item.CgName}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 mr1" *ngIf="Showcourse2">
                    <div class="form-group">
                      <div class="">
                        <mat-form-field appearance="outline" class="example-full-width mt-2">
                          <mat-label>
                          </mat-label>
                          <mat-select #select52 class="colorblack" formControlName="Course2">
                            <mat-select-filter *ngIf="select52.focused" [placeholder]="'Filter'"
                              [displayMember]="'CoName'" [array]="courselist"
                              (filteredReturn)="filteredListCourse =$event">
                            </mat-select-filter>
                            <mat-option value="SelectedData">
                              All
                            </mat-option>
                            <mat-option *ngFor="let item of filteredListCourse" [value]="item.CoCode"
                            (click)="loadgraph('course')">
                              {{item.CoCode}} - {{item.CoName}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 mr1" *ngIf="ShowTown">
                    <div class="form-group">
                      <div class="">
                        <mat-form-field appearance="outline" class="example-full-width mt-2">
                          <mat-label>
                          </mat-label>
                          <mat-select #select521 class="colorblack" formControlName="Town">
                            <mat-select-filter *ngIf="select521.focused" [placeholder]="'Filter'"
                              [displayMember]="'TnName'" [array]="townlist"
                              (filteredReturn)="filteredListTown =$event">
                            </mat-select-filter>
                            <mat-option value="SelectedData">
                              All
                            </mat-option>
                            <mat-option *ngFor="let item of filteredListTown" [value]="item.TnCode"
                            (click)="loadgraph('town')">
                              {{item.TnCode}} - {{item.TnName}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 mr1" *ngIf="ShowDistrict">
                    <div class="form-group">
                      <div class="">
                        <mat-form-field appearance="outline" class="example-full-width mt-2">
                          <mat-label>
                          </mat-label>
                          <mat-select #select522 class="colorblack" formControlName="District">
                            <mat-select-filter *ngIf="select522.focused" [placeholder]="'Filter'"
                              [displayMember]="'DsName'" [array]="districtlist"
                              (filteredReturn)="filteredListDistrict =$event">
                            </mat-select-filter>
                            <mat-option value="SelectedData">
                              All
                            </mat-option>
                            <mat-option *ngFor="let item of filteredListDistrict" [value]="item.DsCode"
                            (click)="loadgraph('district')">
                              {{item.DsCode}} - {{item.DsName}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div style="display: block;">
                  <canvas baseChart 
                    [datasets]="barChartData1"
                    [labels]="barChartLabels1"
                    [options]="barChartOptions1"
                    [plugins]="barChartPlugins1"
                    [legend]="barChartLegend1"
                    [chartType]="barChartType1">
                  </canvas>
                </div>
               </div>
              </div> -->
            <!-- <div class="col-sm-6">
              <div class="card">
                <div class="row">
                  <div class="col-sm-4 mt-4">
                    <mat-radio-group formControlName="CoClg" onkeydown="return (event.keyCode!=13);"
                      class="example-full-width">
                      <div class="row">
                        <div class="col-sm-6">
                          <mat-radio-button class="padding" value='College'
                            (click)="getDrp('College')">College</mat-radio-button>
                        </div>
                        <div class="col-sm-6">
                          <mat-radio-button class="padding" value='Course'
                            (click)="getDrp('Course')">Course</mat-radio-button>
                        </div>
                      </div>
                    </mat-radio-group>
                  </div>
                  <div class="col-sm-2 mr" *ngIf="Showcollege">
                    <div class="form-group">
                      <div class="">
                        <mat-form-field appearance="outline" class="example-full-width mt-2">
                          <mat-label>
                          </mat-label>
                          <mat-select #select52 class="colorblack" formControlName="College">
                            <mat-select-filter *ngIf="select52.focused" [placeholder]="'Filter'"
                              [displayMember]="'CgName'" [array]="collegedataList"
                              (filteredReturn)="filteredListCollege =$event">
                            </mat-select-filter>
                            <mat-option value="SelectedData">
                              All
                            </mat-option>
                            <mat-option *ngFor="let item of filteredListCollege" [value]="item.CgCode"
                              (click)="get(item.CgCode,'college')">
                              {{item.CgCode}} - {{item.CgName}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-2 mr" *ngIf="Showcourse">
                    <div class="form-group">
                      <div class="">
                        <mat-form-field appearance="outline" class="example-full-width mt-2">
                          <mat-label>
                          </mat-label>
                          <mat-select #select52 class="colorblack" formControlName="Course">
                            <mat-select-filter *ngIf="select52.focused" [placeholder]="'Filter'"
                              [displayMember]="'CoName'" [array]="courselist"
                              (filteredReturn)="filteredListCourse =$event">
                            </mat-select-filter>
                            <mat-option *ngFor="let item of filteredListCourse" [value]="item.CoCode"
                              (click)="get(item.CoCode,'course')">
                              {{item.CoCode}} - {{item.CoName}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div style="display: block" class="mt-4">
                      <canvas baseChart [datasets]="barChartData3" [labels]="barChartLabels3"
                        [options]="barChartOptions3" [legend]="barChartLegend3" [chartType]="barChartType3">
                      </canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="card">
                <div class="row">
                  <div class="col-sm-12 mgtp">

                  </div>
                  <div class="col-sm-12">
                    <div style="display: block">
                      <canvas class="pie1" baseChart [data]="pieChartData" [labels]="pieChartLabels"
                        [options]="pieChartOptions" [colors]="piecolors" [chartType]="'pie'">
                      </canvas>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-sm-6">
              <div class="card">
                <div style="display: block">
                  <canvas baseChart [data]="doughnutChartData" [labels]="doughnutChartLabels"
                    [options]="doughnutChartOptions" [colors]="doughnutColor" [chartType]="doughnutChartType">
                  </canvas>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="card">
                <div style="display: block">
                  <canvas baseChart [datasets]="barChartData2" [labels]="barChartLabels2" [options]="barChartOptions2"
                    [legend]="barChartLegend2" [chartType]="barChartType1">
                  </canvas>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="card">
                <div class="scroll-container">
                  <div style="width: 100%; overflow-x: auto;">
                    <div style="display: block">
                      <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
                        [legend]="barChartLegend" [chartType]="barChartType">
                      </canvas>
                    </div>
                  </div>
                </div>

              </div>
            </div> -->



          </div>

        </div>
      </div>
    </div>
  </div>
</div>